import { StringUtils } from '@localina/core';
import React from 'react';

interface IProps {
    language: string;
    extraClassName?: string;
}

export const LanguageCode: React.FC<IProps> = (props) => (
    <span className={StringUtils.combineStrings(['language-code', props.extraClassName])}>
        {props.language.toUpperCase()}
    </span>
);
